// API Base URLs
export const API_URL = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_API_URL;
export const CORE_URL = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_CORE_URL;
export const AUTHENTICATION_URL =
  process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_AUTH_URL;
export const REDIRECT_URI = encodeURIComponent(
  process.env.REACT_APP_SSO_REDIRECT_URI || window.location.origin
);

// API Endpoints
export const CHAT_API = `${API_URL}/ws`;
// File retrieval now requires case number: /getfile/{case_number}/{filename}
export const GET_FILE_API = (caseNumber) => `${API_URL}/getfile/${encodeURIComponent(caseNumber)}`;
export const UPDATE_CASE_DETAILS_API = `${CORE_URL}/update_case_status`;
export const SEND_EMAIL_API = `${CORE_URL}/send_email`;
export const AUTH_API = `${AUTHENTICATION_URL}/login`;
